import script from "./VHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./VHeader.vue?vue&type=script&setup=true&lang=ts"

import "./VHeader.vue?vue&type=style&index=0&id=5c0c3f8e&lang=css"

const __exports__ = script;

export default __exports__